import * as nm from 'src/generated/api/nm.api';

type NotificationList = nm.paths['/api/notification/getAllPageable']['post'];
export type NotificationListParams = NotificationList['parameters']['body']['filterDataDto'];
export type NotificationListResp = NotificationList['responses']['200']['schema'];
export type UserNotification = NotificationListResp['data']['data']['data'][0];
